import { ListFilter, Newspaper } from "lucide-react";
import CountUp from "react-countup";
import { useSelector } from "react-redux";
import { RootState } from "../../slices";

const Widgets = () => {
  const { chartData } = useSelector((state: RootState) => state.Dashboard);

  return (
    <div className="grid grid-cols-12 mb-5 gap-x-5">
      <div className="order-1 md:col-span-6 lg:col-span-4 col-span-12 bg-green-100 dark:bg-green-500/20 card group-data-[skin=bordered]:border-green-500/20 relative overflow-hidden">
        <div className="card-body">
          <ListFilter className="absolute top-0 stroke-1 size-32 text-green-200/50 dark:text-green-500/20 ltr:-right-10 rtl:-left-10"></ListFilter>
          <div className="flex items-center justify-center bg-green-500 rounded-md size-12 text-15 text-green-50">
            <Newspaper />
          </div>
          <h5 className="mt-5 mb-2">
            <CountUp end={chartData.totalOrders} className="counter-value" />
          </h5>
          <p className="text-slate-500 dark:text-slate-200">Pedidos feitos</p>
        </div>
      </div>
      <div className="order-2 md:col-span-6 lg:col-span-4 col-span-12 bg-orange-100 dark:bg-orange-500/20 card group-data-[skin=bordered]:border-orange-500/20 relative overflow-hidden">
        <div className="card-body">
          <ListFilter className="absolute top-0 stroke-1 size-32 text-orange-200/50 dark:text-orange-500/20 ltr:-right-10 rtl:-left-10"></ListFilter>
          <div className="flex items-center justify-center bg-orange-500 rounded-md size-12 text-15 text-orange-50">
            <Newspaper />
          </div>
          <h5 className="mt-5 mb-2">
            <CountUp end={chartData.pendingOrders} className="counter-value" />
          </h5>
          <p className="text-slate-500 dark:text-slate-200">Pedidos pendentes</p>
        </div>
      </div>
      <div className="order-3 md:col-span-6 lg:col-span-4 col-span-12 bg-sky-100 dark:bg-sky-500/20 card group-data-[skin=bordered]:border-sky-500/20 relative overflow-hidden">
        <div className="card-body">
          <ListFilter className="absolute top-0 stroke-1 size-32 text-sky-200/50 dark:text-sky-500/20 ltr:-right-10 rtl:-left-10"></ListFilter>
          <div className="flex items-center justify-center rounded-md size-12 bg-sky-500 text-15 text-sky-50">
            <Newspaper />
          </div>
          <h5 className="mt-5 mb-2">
            <CountUp end={chartData.syncedOrders} className="counter-value" />
          </h5>
          <p className="text-slate-500 dark:text-slate-200">Pedidos sincronizados</p>
        </div>
      </div>
    </div>
  );
};

export default Widgets;
